<!-- Échec : on le dit, avec un moyen de réessayer. Aucune donnée de repli. -->
@if (errored()) {
  <app-error-state
    [titleKey]="errorTitleKey()"
    [messageKey]="errorMessageKey()"
    [detail]="errorDetail()"
    (retry)="retry.emit()">
  </app-error-state>
} @else {

  @if (!isEmpty()) {
    <!-- La table défile dans son propre conteneur : la page ne bouge pas. -->
    <div class="dt__wrap">
      <table class="dt__table">
        <thead>
          <tr>
            @for (col of columns(); track col.key) {
              <th scope="col"
                  class="dt__th"
                  [class.dt__th--num]="col.numeric"
                  [class.dt__th--center]="col.align === 'center'"
                  [class.dt__th--sortable]="col.sortable"
                  [class.dt__th--action]="col.action"
                  [class.dt__th--hide-md]="col.hideBelow === 'md'"
                  [class.dt__th--hide-lg]="col.hideBelow === 'lg'"
                  [class.is-active]="isSortedBy(col)"
                  [style.width]="col.width || null"
                  (click)="onSort(col)">
                @if (col.sortable) {
                  <button type="button" class="dt__sort">
                    {{ col.labelKey | translate }}
                    <i [class]="'fa-solid ' + sortIcon(col)" aria-hidden="true"></i>
                  </button>
                } @else {
                  {{ col.labelKey | translate }}
                }
              </th>
            }
          </tr>
        </thead>

        <tbody>
          @if (loading()) {
            @for (row of skeletonRowList(); track row) {
              <tr class="dt__skel-row" aria-hidden="true">
                @for (cell of skeletonCells(); track cell) {
                  <td class="dt__skel-cell"><span class="dt__skel-bar"></span></td>
                }
              </tr>
            }
          } @else {
            @for (row of rows(); track trackRow($index, row); let i = $index) {
              <tr class="dt__row">
                <ng-container
                  [ngTemplateOutlet]="rowTemplate()"
                  [ngTemplateOutletContext]="{ $implicit: row, index: i }">
                </ng-container>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Succès mais sans résultat : état vide. -->
  @if (isEmpty()) {
    <app-empty-state
      [icon]="emptyIcon()"
      [titleKey]="emptyTitleKey()"
      [messageKey]="emptyMessageKey()">
    </app-empty-state>
  }

  <!-- Pagination serveur (optionnelle). -->
  @if (showPager() && !isEmpty()) {
    <nav class="dt__pager" [attr.aria-label]="'DATA_TABLE.PAGINATION.LABEL' | translate">
      <label class="dt__page-size">
        <span>{{ 'DATA_TABLE.PAGINATION.PAGE_SIZE' | translate }}</span>
        <select [value]="pageSize()"
                [disabled]="loading()"
                (change)="onPageSize($any($event.target).value)">
          @for (size of pageSizes(); track size) {
            <option [value]="size">{{ size }}</option>
          }
        </select>
      </label>

      <div class="dt__pager-nav">
        <button type="button" class="dt__pager-btn"
                [disabled]="!canPrevious()"
                (click)="previousPage()">
          <i class="fa-solid fa-chevron-left dt__chev" aria-hidden="true"></i>
          {{ 'DATA_TABLE.PAGINATION.PREVIOUS' | translate }}
        </button>

        <span class="dt__pager-state">
          {{ 'DATA_TABLE.PAGINATION.PAGE_OF' | translate:
             { current: currentPage(), total: totalPages() } }}
        </span>

        <button type="button" class="dt__pager-btn"
                [disabled]="!canNext()"
                (click)="nextPage()">
          {{ 'DATA_TABLE.PAGINATION.NEXT' | translate }}
          <i class="fa-solid fa-chevron-right dt__chev" aria-hidden="true"></i>
        </button>
      </div>
    </nav>
  }
}
